import { Link } from "react-router-dom";
import React from "react";

const BlogCard = React.memo(({ blog }) => (
  <Link to={`/blog/${blog.id}`} key={blog.id}>
<div className="bg-[#112240] p-4 rounded-xl shadow-sm transition-transform transform hover:scale-105 cursor-pointer">
<img
        src={blog.image}
        alt="Blog"
        className="w-full h-40 object-cover rounded-lg mb-4"
        loading="lazy"  // Lazy load images
      />
      <h3 className="text-xl font-semibold text-white mb-2">
        {blog.title}
      </h3>
      <p className="text-gray-400 mb-3">
        {blog.description.slice(0, 100)}...
      </p>
      <div className="flex items-center text-gray-400 text-sm">
        <span>{blog.author}</span>
        <span className="mx-2">•</span>
        <span>{blog.date}</span>
      </div>
    </div>
  </Link>
));

export default BlogCard;
